import $http from '@/resource'
import utils from '@/utils'
import remark from './remark'
import input from './input'

const $api = Object.assign({}, remark, input)

/**
 * 用来拼接项目搜索的搜索条件
 *
 * @param {object} params 搜索项数组
 *
 * @date 2018-9-28 14:18:09
 *
 * @returns {string}
 */
$api.getItemSearchQuery = (params) => {
  let query = ''
  for (let i in params) {
    if (i === 'orderWord') {
      if (Array.isArray(params[i]) === true) {
        query += `&orderWord=${params[i][0]}_${params[i][1]}`
      } else {
        //针对排序条件做obj->string
        if (Object.keys(params[i]).length > 0) {
          for (let k in params[i]) {
            query += '&orderWord=' + k + '_' + params[i][k]
          }
        }
      }

    } else if (i === 'totalprogress') {
      if (params[i].length > 0) {
        query += '&totalprogress=' + ((typeof params[i] !== 'string') ? params[i].join(',') : params[i])
      }
    } else if (i === 'totalstatus') {
      if (params[i].length > 0) {
        query += '&totalstatus=' + ((typeof params[i] !== 'string') ? params[i].join(',') : params[i])
      }
    } else if (i === 'dataRanger') {
      if (!(params[i][0] === '' && params[i][1] === '') && params[i].length > 0) {
        query += '&dataRanger=' + params[i].join('~')
      }
    } else if (i === 'cloudRanger') {
      if (!(params[i][0] === '' && params[i][1] === '') && params[i].length > 0) {
        query += '&cloudRanger=' + params[i].join('~')
      }
    } else if (i === 'nexttime') {
      if (!(params[i][0] === '' && params[i][1] === '') && params[i].length > 0) {
        query += '&nexttime=' + params[i].join('~')
      }
    } else if (i === 'entrytime') {
      if (!(params[i][0] === '' && params[i][1] === '') && params[i].length > 0) {
        query += '&entrytime=' + params[i].join('~')
      }
    } else {
      query += `&${i}=${params[i]}`
    }
  }
  query = query.substr(1)
  return query
}

/**
 * 获取项目列表导出excelURL
 *
 * @param {object} params 搜索项
 *
 * @date 2018-9-28 16:10:48
 *
 * return String
 */
$api.getDownloadListUrl = (params) => {
  let query = $api.getItemSearchQuery(params)
  let url = 'item/exporting'
  if (query && query !== '') {
    url += `?${query}`
  }
  return url
}

/**
 * 获取项目列表[做了字段过滤]
 *
 * @param {object} params 搜索项数组
 *
 * @date 2018-9-19 16:08:01
 *
 * @returns {Promise<any>}
 */
$api.getItemList = (params) => {
  let query = $api.getItemSearchQuery(params)

  // console.log(query);
  const url = `items?${query}`
  const promise = new Promise(resolve => {
    $http.get(url).then(response => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取搜索备选项缓存
 *
 * @param {string} uid 用户uid
 * @param {string} cate 项目类型 1：土地，2：厂房，3：商业，4：写字楼，5：注册，6：客户，7：仓库，10：其他
 *
 * @date 2018-9-21 18:16:03
 *
 * @returns {Promise<any>}
 */
$api.getDefaultSearchData = function (uid, cate = '') {
  const url = `user/${uid}/item-search-cache?cate=${cate}`
  const promise = new Promise(function (resolve) {
    $http.get(url).then(function (response) {
      resolve(response)
    })
  })
  return promise
}

/**
 * 发起项目回收
 *
 * @param {string} id 要回收的项目id
 *
 * @date 2018-9-25 11:22:42
 *
 * @returns {Promise<any>}
 */
$api.recycleItem = (id) => {
  const url = `item/${id}/recycling`
  const promise = new Promise((resolve) => {
    $http.put(url).then((response) => {
      resolve(response)
    })
  })
  return promise
};

/**
 * 批量回收|还原项目
 *
 * @author zyz 2020-7-10 11:49:37
 *
 * @method put
 *
 * @param {Array} ids 待操作的项目id数组
 * @param {String} status 操作状态3-回收0-还原
 *
 * @url item/batch-recycle
 *
 * @return {Promise<void>}
 */
$api.batchRecycleItem = async (ids,status)=>{
    const url = `item/batch-recycle`;
    return await $http.put(url,{'ids':ids,"status":status});
};

/**
 * 批量查看项目
 *
 * @param {array} ids 待查看的项目id数组
 *
 * @date 2018-9-25 11:43:03
 *
 * @returns {Promise<any>}
 */
$api.batchReadItem = (ids) => {
  const url = `item/batch-view`
  const promise = new Promise((resolve) => {
    $http.patch(url, {ids: ids}).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 批量推送项目
 *
 * @param {object} postData 待推送的项目和人的object
 *
 * @date 2018-9-30 14:47:28
 *
 * @returns {Promise<any>}
 */
$api.batchPushItem = (postData) => {
  const url = `item/push-item`
  const promise = new Promise((resolve) => {
    $http.post(url, postData).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取项目详情数据
 *
 * @param {string} itemId 项目id
 *
 * @date 2018-10-9 10:01:36
 *
 * @returns {Promise<any>}
 */
$api.getItemDetail = (itemId) => {
  const url = `item/${itemId}/detail`
  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}
/**
 * 获取企业详情数据
 *
 * @param {string} companyId 企业id
 *
 * @date 2018-10-9 10:01:36
 *
 * @returns {Promise<any>}
 */
$api.getCompanyDetail = (companyId) => {
  const url = `companys/${companyId}/detail`
  const promise = new Promise((resolve) => {
    $http.get(url).then( (response)=>{
      resolve(response);
    });
  })

  return promise
}
/**
 * 获取载体详情数据
 *
 * @param {string} carrierId 载体id
 *
 * @date 2019-9-12 10:01:36
 *
 * @returns {Promise<any>}
 */
$api.getCarrierDetail = (carrierId) => {
  const url = `carrier/${carrierId}/detail`
  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}
/**
 * 删除用户查看项目的权限
 *
 * @param {string} itemId 项目id
 * @param {string} id 对应权限在表中的id
 *
 * @date 2018-10-11 11:26:43
 *
 * @returns {Promise<any>}
 */
$api.deleteItemViewAuth = (itemId, id) => {
  // const url = `item-permissions/${id}`;
  const url = `item/${itemId}/permission?pid=${id}`
  const promise = new Promise((resolve) => {
    $http.delete(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取微信那边生成的二维码
 *
 * @param {string} type 类型，item-项目,carrier-载体
 * @param {object} params 需要携带的相关参数，这之中必须包含id,type 01:载体 10:项目,to do 000:关注操作
 *
 * @date 2018-10-11 17:31:38
 *
 * @returns {Promise<any>}
 */
$api.getWeChatQrCode = (type, params) => {
  let url = type === 'item' ? `item/${params.id}/qrcode` : `carrier/${params.id}/qrcode`
  url += `?type=${params.type}&todo=${params.todo}`
  const promise = new Promise(resolve => {
    $http.get(url).then(response => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 改变项目|载体关注状态
 *
 * @param {string} type 类型，item-项目,carrier-载体
 * @param {string} id  项目|载体 id
 * @param {string} status 要修改成的状态
 *
 * @date 2018-10-11 19:18:20
 *
 * @returns {Promise<any>}
 */
$api.changeFocusStatus = (type, id, status) => {
  let url = type === 'item' ? `item/${id}/focus` : `carrier/${id}/focus`
  const promise = new Promise(resolve => {
    $http.patch(url, {'changeFocus': status}).then(response => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 改变项目进度完成状态
 *
 * @param {string} id  项目 id
 * @param {string} status 要修改成的状态
 * @param {string} remindType 进度类型
 * @date 2018-10-11 19:18:20
 *
 * @returns {Promise<any>}
 */
$api.changeRemarkStatus = (id, status, remindType) => {
  let url = `item/${id}/remind`
  const promise = new Promise(resolve => {
    $http.patch(url, {'status': status, 'remindType': remindType}).then(response => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 编辑项目上会批复
 *
 * @param {string} id  项目 id
 * @param {Object} postData 编辑数据
 * @date 2018-10-11 19:18:20
 *
 * @returns {Promise<any>}
 */
$api.updateReply = (id,postData) => {
  const url = `item/${id}/remind-reply`;
  const data={
      'replyFile':postData.fileId,
      'replyStartTime':postData.timeRanger[0],
      'replyEndTime':postData.timeRanger[1]
    };
  const promise = new Promise(resolve => {
    $http.patch(url, data).then(response => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 编辑项目交地确认
 *
 * @param {string} id  项目 id
 * @param {Object} postData 编辑数据
 * @date 2018-10-11 19:18:20
 *
 * @returns {Promise<any>}
 */
$api.updateLandExchange = (id,postData) => {
  const url = `item/${id}/remind-land-exchange`;
  const data={
    'landExchangeFile':postData.fileId,
    'landExchangeTime':postData.landExchangeTime,
  };
  const promise = new Promise(resolve => {
    $http.patch(url, data).then(response => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 编辑投资协议
 *
 * @param {string} id  项目 id
 * @param {Object} postData 编辑数据
 * @date 2018-10-11 19:18:20
 *
 * @returns {Promise<any>}
 */
$api.updateInvest = (id,postData) => {
  const url = `item/${id}/remind-invest`;
  const data={
    'investType':postData.investType,
    'workCreate':postData.workCreate,
    'workComplete':postData.workComplete,
    'workProduct':postData.workProduct,
    'productRequire':postData.productRequire,
    'taxRequire':postData.taxRequire,
    'investFile':postData.fileId,
  };
  const promise = new Promise(resolve => {
    $http.patch(url, data).then(response => {
      resolve(response)
    })
  })
  return promise
}


/**
 * 编辑土地出让合同
 *
 * @param {string} id  项目 id
 * @param {Object} postData 编辑数据
 * @date 2018-10-11 19:18:20
 *
 * @returns {Promise<any>}
 */
$api.updateContract = (id,postData) => {
  const url = `item/${id}/remind-contract`;
  const data={
    'landContractFile':postData.fileId,
    'landCompleteTime':postData.landCompleteTime,
  };
  const promise = new Promise(resolve => {
    $http.patch(url, data).then(response => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取企业诉求数据
 *
 * @param {number} itemId 项目id
 *
 * @date 2018-10-16 11:38:00
 *
 * @returns {Promise<any>}
 */

$api.getBusinessDemands = (itemId) => {
  const url = `/item/${itemId}/type/1/appeals`
  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 添加企业诉求数据
 *
 * @param {object} postData 待推送的企业诉求数据
 *
 * @date 2018-10-16 11:38:00
 *
 * @returns {Promise<any>}
 */

$api.addDemand = (postData) => {
  const url = `/item-appeals`
  const promise = new Promise((resolve) => {
    $http.post(url, postData).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 更新企业诉求数据
 *
 * @param {object} putData 待更新的企业诉求数据
 *
 * @date 2018-10-16 11:38:00
 *
 * @returns {Promise<any>}
 */

$api.updataDemand = (putData) => {
  const url = `/item-appeals`
  const promise = new Promise((resolve) => {
    $http.put(url, putData).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 删除企业诉求数据
 *
 * @param {number} id 企业诉求id
 * @param {number} itemId 项目id
 *
 * @date 2018-10-16 11:38:00
 *
 * @returns {Promise<any>}
 */

$api.removeDemand = (id, itemId) => {
  const url = `/item-appeals?id=${id}&item_id=${itemId}`
  const promise = new Promise((resolve) => {
    $http.delete(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取项目名片数据
 *
 * @param {number} itemId 项目id
 *
 * @date 2018-10-16 11:38:00
 *
 * @returns {Promise<any>}
 */

$api.getCardData = (itemId, isView) => {
  const url = `/item/${itemId}/cards?isView=${isView}`
  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取企业名片数据
 *
 * @param {number} companyId  企业id
 *
 * @date 2018-10-16 11:38:00
 *
 * @returns {Promise<any>}
 */

$api.getCompanyCardData = (companyId, isView) => {
  const url = `/companys/${companyId}/cards?isView=${isView}`
  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}
/**
 * 获取项目标签数据
 *
 * @param {number} itemId 项目id
 *
 * @date 2018-10-17 16:09
 *
 * @returns {Promise<any>}
 */

$api.getTagsData = (itemId) => {
  const url = `/item/${itemId}/tags`
  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  });
  return promise
};

/**
 * 删除项目标签数据
 *
 * @param {number} itemId 项目id
 * @param {number} tagId 标签id
 *
 * @date 2018-10-18 09:20
 *
 * @returns {Promise<any>}
 */

$api.removeTag = (itemId, tagId) => {
  const url = `/item/${itemId}/tags?tagid=${tagId}`
  const promise = new Promise((resolve) => {
    $http.delete(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 添加项目标签数据
 *
 * @param {number} itemId 项目id
 * @param {number} tagId 标签id
 *
 * @date 2018-10-18 09:20
 *
 * @returns {Promise<any>}
 */

$api.addTag = (itemId, tagId) => {
  const url = `/item/${itemId}/tags?tagid=${tagId}`
  const promise = new Promise((resolve) => {
    $http.post(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取回看列表数据
 *
 * @param {number} itemId 项目id
 * @param {string} type 类型 1-项目，2-载体
 *
 * @date 2018-10-23 10:44
 *
 * @returns {Promise<any>}
 */

$api.getLookBack = (itemId, type = '1') => {
  const url = type === '1' ? `/item/${itemId}/lookback` : `carrier/${itemId}/lookback`
  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 添加回看列表数据
 *
 * @param {number} itemId 项目id
 * @param {Array} backTime 回看数据
 * @param {String} type 类型1-项目2-载体
 *
 * @date 2018-10-23 10:44
 *
 * @returns {Promise<any>}
 */

$api.addLookBack = (itemId, backTime, type = '1') => {
  const url = type === '1' ? `/item/${itemId}/lookback` : `carrier/${itemId}/lookback`
  const promise = new Promise((resolve) => {
    $http.post(url, backTime).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 修改回看状态
 *
 * @param {number} itemId 项目id
 * @param {Object} lookBackStatus 更新的回看数据
 * @param {Stinrg} type 类型1-项目2-载体
 *
 * @date 2018-10-23 13:48
 *
 * @returns {Promise<any>}
 */

$api.changeLookBackStatus = (itemId, lookBackStatus, type = '1') => {
  const url = type === '1' ? `/item/${itemId}/lookback` : `carrier/${itemId}/lookback`
  const promise = new Promise((resolve) => {
    $http.patch(url, lookBackStatus).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取商业-经营行业的备选项
 */
$api.getBusinessTradeList = () => {
  const url = `industry-business`
  const promise = new Promise(resolve => {
    $http.get(url).then(response => {
      if (response.code === '200') {
        resolve(response.data)
      } else {
        utils.notice(response.msg, 'error')
      }
    })
  })
  return promise
}

/**
 * 设置项目的需求分类
 *
 * @param {string} itemId 项目id
 * @param {string} itemCate 需求分类
 *
 * @date 2018-12-5 11:01:40
 *
 * @returns {promise}
 */
$api.setItemNeedType = (itemId = '', itemCate = '') => {
  if (!itemId || !itemCate) {
    return false
  }
  const url = `item/${itemId}/need-classify`
  const promise = new Promise((resolve) => {
    $http.put(url, {'ims_item_cate': itemCate}).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 移动项目|修改项目类型
 *
 * @param {string} itemId 项目id
 * @param {string} cate 要移动至的分类
 *
 * @date 2018-12-5 11:02:49
 *
 * @returns {promise}
 */
$api.setItemCate = (itemId = '', cate = '') => {
  if (!itemId || !cate) {
    return false
  }
  const url = `item/${itemId}/item-move`
  const promise = new Promise((resolve) => {
    $http.put(url, {'cate': cate}).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 添加附件
 * @param {string} itemId 项目id
 * @param {object} postData 待提交的数据
 *
 * @date 2018-12-5 15:03:08
 *
 * @return {Promise}
 */
$api.addFile = (itemId = '', postData = {}) => {
  if (!itemId || !postData) {
    return false
  }
  const url = postData.type === '1' ? `item/${itemId}/attachment-upload` : `carrier/${itemId}/attachment-upload`
  const promise = new Promise((resolve) => {
    $http.post(url, postData).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 查询号码归属地
 *
 * @param {string} type 类型 1- 手机 2- 座机
 * @param {string} num 手机号|座机区号
 *
 * @date 2018-12-6 15:44:49
 *
 * @return {Promise}
 */
$api.getMobileAddress = (type = '', num = '') => {
  if (!num || !type) {
    return false
  }
  const url = `mobile-attribution?mobile=${num}&type=${type}`
  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 查询项目名片手机号重复
 *
 * @param {String} content 查询内容
 * @param {String} type 类型，mobile-手机号
 * @param {String} id 名片id,编辑的时候用
 *
 * @date 2019-10-14 14:10:14
 *
 * @returns {Promise<void>}
 */
$api.getItemCardRepeat = async (content = '', type = '', id = '') => {
  const url = `item/card-repeat?content=${content}&type=${type}&id=${id}`
  return await $http.get(url)
}

/**
 * 项目提取操作
 *
 * @param {string} ids 要提取的项目id
 * @param {string} types 要提取的条目类型
 *
 * @date 2019-10-15 11:33:32
 *
 * @returns {Promise<void>}
 */
$api.extractItem = async (ids = '', types = '') => {
  const url = `item/item-extract`
  return await $http.post(url, {'ids': ids, 'types': types})
}

/**
 * 查询名片电话号标记
 *
 * @param {string} type 类型1-手机2-座机
 * @param {string} num 手机号/座机号（座机号格式 区号-座机号）
 *
 * @date 2018-12-6 17:22:37
 *
 * @returns {boolean}
 */
$api.getMobileRemark = (type = '', num = '') => {
  if (!num || !type) {
    return false
  }
  const url = `item/card-sign?mobile=${num}&type=${type}`
  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 添加名片
 *
 * @param {string} itemId 项目id
 * @param {object} postData 待提交的数据
 *
 * @date 2018-12-6 17:22:46
 *
 * @returns {Promise}
 */
$api.addCard = (itemId = '', postData = {}) => {
  if (!itemId || Object.keys(postData).length <= 0) {
    return false
  }
  const url = `item/${itemId}/card`
  const promise = new Promise((resolve) => {
    $http.post(url, postData).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 编辑名片
 *
 * @param {string} itemId 项目id
 * @param {string} cid 名片id
 * @param {object} postData 待提交的数据
 *
 * @date 2018-12-6 19:29:36
 *
 * @returns {Promise}
 */
$api.editCard = (itemId = '', cid = '', postData = {}) => {
  if (!itemId || !cid || Object.keys(postData).length <= 0) {
    return false
  }
  const url = `item/${itemId}/card/${cid}`
  const promise = new Promise((resolve) => {
    $http.put(url, postData).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 删除一张名片
 *
 * @param {string} itemId 项目id
 * @param {string} cid 要删除的名片id
 *
 * @date 2018-12-25 09:47:51
 *
 * @return {Promise}
 */
$api.deleteCard = (itemId = '', cid = '') => {
  const url = `item/${itemId}/card/${cid}`
  const promise = new Promise(resolve => {
    $http.delete(url).then(response => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取附件分类列表
 *
 * @param {string} type 1：项目 2：载体
 * @param {string} cate 1：土地，2：厂房，3：商业，4：写字楼，5：注册，6：客户，7：仓库，10：其他
 *
 */
$api.getfileClass = (type, cate) => {
  const url = 'file-class'
  const promise = new Promise(resolve => {
    $http.get(url, {params: {type, cate}}).then(response => {
      if (response.code === '200') {
        resolve(response.data)
      } else {
        utils.notice(response.msg, 'error')
      }
    })
  })
  return promise
}

/*
 * 添加名片标记
 *
 * @param {string} cid 名片id
 * @param {string} type 修改类型1-手机，2-座机
 * @param {string} mobile_ref 标记内容
 *
 * @date 2018-12-6 20:48:40
 *
 * @return {Promise}
 */
$api.editCardSign = (cid = '', type = '', mobile_ref = '') => {
  if (!cid || !type) {
    return false
  }

  const url = `item/card/${cid}/card-sign`
  const promise = new Promise((resolve) => {
    $http.patch(url, {'type': type, 'mobile_ref': mobile_ref}).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取项目|载体对接数据
 *
 * @param {string} type 类型 1-项目，2-载体
 * @param {string} id 项目|载体id
 * @param {string} page 页码数
 * @param {string} pageSize 单页条数
 *
 * @date 2018-12-7 10:48:20
 *
 * @return {Promise}
 *
 */
$api.getRelationData = (type = '1', id = '', page = '1', pageSize = '10') => {
  if (!id) {
    return false
  }
  let url = ''
  if (type === '1') {
    //项目
    url = `item/${id}/docking-carrier`
  } else {
    //载体
    url = `carrier/${id}/docking-item`
  }

  url += `?page_size=${pageSize}&page=${page}`

  const promise = new Promise((resolve) => {
    $http.get(url).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 编辑项目|载体对接数据
 *
 * @param {string} type 类型 1-项目2-载体
 * @param {string} fid 项目id|载体index_id
 * @param {string} postData 待提交的修改数据
 *
 * @date 2018-12-7 16:07:32
 *
 * @returns {Promise}
 */
$api.editRelationData = (type = '1', fid = '', postData = {}) => {
  if (!fid || Object.keys(postData).length <= 0) {
    return false
  }
  let url = type === '1' ? `item/${fid}/docking-carrier` : `carrier/${fid}/docking-item`

  const promise = new Promise((resolve) => {
    $http.put(url, postData).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 获取导出项目|载体对接数据url
 *
 * @param {string} type 1-项目2-载体
 * @param {string} id 项目|载体id
 *
 * @date 2018-12-7 16:45:45
 *
 * @return {String}
 */
$api.getRelationExportUrl = (type = '1', id = '') => {
  let url = ''
  if (type === '1') {
    url = `item/${id}/docking-carrier-export`
  } else {
    url = `carrier/${id}/docking-item-export`
  }
  return url
}

/**
 * 添加目|载体对接数据
 *
 * @param {String} type 类型 1-项目，2-载体
 * @param {String} id 项目|载体id
 * @param {array} ids 添加的条目id
 *
 * @date 2018-12-8 13:53:24
 *
 * @return {Promise}
 */
$api.addRelationData = (type = '1', id = '', ids = []) => {
  let url = ''
  let postData = {}
  if (type === '1') {
    //项目
    url = `item/${id}/docking-carrier`
    postData = {carrier_ids: ids}
  } else {
    //载体
    url = `carrier/${id}/docking-item`
    postData = {item_ids: ids}
  }
  const promise = new Promise((resolve) => {
    $http.post(url, postData).then((response) => {
      resolve(response)
    })
  })
  return promise
}

/**
 * 删除名片图片
 *
 * @author zyz 2020-7-14 16:29:17
 *
 * @method delete
 *
 * @param {String} cardId 名片id
 * @param {String} picId 图片id
 *
 * @url item/card-file/{cid}
 *
 * @return {Promise<void>}
 */
$api.deleteCardPic = async (cardId,picId)=>{
  const url = `item/card-file/${cardId}?fileId=${picId}`;
  return await $http.delete(url);
};

export default $api



// WEBPACK FOOTER //
// ./src/service/item/index.js